export const dictionary = {
    courseHistory: "Course History",
    notOffered: "Not offered",
    courseCountInfo1: "Total<space/><bold>{{count}}</bold><space/>courses<space/>",
    courseCountInfo2: "(<icon/>: Open this semester)",
    sort: "Sort",
    noResults: "No results",
    sortOptions: {
        code: "By Course Code",
        popularity: "By Popularity",
        studentCount: "By Enrollment",
    },
    review: "Course Reviews",
    reviewLanguage: "Language",
    reviewLanguageOptions: {
        all: "All",
        english: "English",
    },
}
